<template>
  <div id="app" :class="[{ 'closed-large-overview': this.largeOverview }, { 'expanded-small-overview': this.smallOverview }]">
    <main-header :monthlyPaymentSelected="$root.monthlyPaymentSelected" :total="$root.totalOutput" @toggleClicked="toggleMenu()"/>
    <mini-overview />
    <overview @itemClicked="closeSmallOverview()" :windowWidth="window.width" />
    <main id="main-content">
      <div id="overlay" @click="toggleMenu()"></div>
      <price-badge :monthlyPaymentSelected="$root.monthlyPaymentSelected" :total="$root.totalOutput"></price-badge>
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
      <transition name="fade" mode="out-in">
        <cookie-banner v-if="cookieBanner" />
      </transition>
    </main>
  </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue'
import Overview from '@/components/Overview.vue'
import MiniOverview from '@/components/MiniOverview.vue'
import PriceBadge from '@/components/PriceBadge.vue'
import CookieBanner from '@/components/CookieBanner.vue'
export default {
  components: {
    MainHeader,
    Overview,
    MiniOverview,
    PriceBadge,
    CookieBanner
  },
  data: function () {
    return {
      largeOverview: true,
      smallOverview: false,
      window: {
        width: 0,
        height: 0
      }
    }
  },
  methods: {
    handleResize: function () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
      if (this.smallOverview === true && this.window.width >= 1180) {
        this.smallOverview = !this.smallOverview
      }
    },
    toggleModal: function () {
      this.modalOpen = false
    },
    toggleMenu: function () { // drawer menu toggle in header clicked -> this function is called
      this.$root.resizeHandler = !this.$root.resizeHandler
      if (this.window.width < 1180) {
        this.smallOverview = !this.smallOverview
      } else {
        this.largeOverview = !this.largeOverview
      }
    },
    closeSmallOverview: function () {
      if (this.smallOverview === true) {
        this.smallOverview = false
      }
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  mounted () {
    /*
    window.addEventListener('load', () => {
      FastClick.attach(document.body)
    }, false)
    */
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    /*
    user: function () {
      return this.$root.user
    },
    */
    cookieBanner: function () {
      return this.$root.cookieBanner
    }
  }
}

</script>

<style lang="scss">
@import 'assets/css/reboot.css';
@import "assets/css/variables.scss";

*:focus {
  outline: none!important;
}

@font-face {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 800;
  src: url('assets/fonts/montserrat-v14-latin/montserrat-v14-latin-800.eot'); /* IE9 Compat Modes */
  src: local('Montserrat ExtraBold'), local('Montserrat-ExtraBold'),
       url('assets/fonts/montserrat-v14-latin/montserrat-v14-latin-800.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('assets/fonts/montserrat-v14-latin/montserrat-v14-latin-800.woff2') format('woff2'), /* Super Modern Browsers */
       url('assets/fonts/montserrat-v14-latin/montserrat-v14-latin-800.woff') format('woff'), /* Modern Browsers */
       url('assets/fonts/montserrat-v14-latin/montserrat-v14-latin-800.ttf') format('truetype'), /* Safari, Android, iOS */
       url('assets/fonts/montserrat-v14-latin/montserrat-v14-latin-800.svg#Montserrat') format('svg'); /* Legacy iOS */
}

/* montserrat-600 - latin */
@font-face {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  src: url('assets/fonts/montserrat-v14-latin/montserrat-v14-latin-600.eot'); /* IE9 Compat Modes */
  src: local('Montserrat SemiBold'), local('Montserrat-SemiBold'),
       url('assets/fonts/montserrat-v14-latin/montserrat-v14-latin-600.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('assets/fonts/montserrat-v14-latin/montserrat-v14-latin-600.woff2') format('woff2'), /* Super Modern Browsers */
       url('assets/fonts/montserrat-v14-latin/montserrat-v14-latin-600.woff') format('woff'), /* Modern Browsers */
       url('assets/fonts/montserrat-v14-latin/montserrat-v14-latin-600.ttf') format('truetype'), /* Safari, Android, iOS */
       url('assets/fonts/montserrat-v14-latin/montserrat-v14-latin-600.svg#Montserrat') format('svg'); /* Legacy iOS */
}

/* muli-600italic - latin */
@font-face {
  font-family: 'Muli';
  font-style: italic;
  font-weight: 600;
  src: url('assets/fonts/muli-v16-latin/muli-v16-latin-600italic.eot'); /* IE9 Compat Modes */
  src: local('Muli SemiBold Italic'), local('Muli-SemiBoldItalic'),
       url('assets/fonts/muli-v16-latin/muli-v16-latin-600italic.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('assets/fonts/muli-v16-latin/muli-v16-latin-600italic.woff2') format('woff2'), /* Super Modern Browsers */
       url('assets/fonts/muli-v16-latin/muli-v16-latin-600italic.woff') format('woff'), /* Modern Browsers */
       url('assets/fonts/muli-v16-latin/muli-v16-latin-600italic.ttf') format('truetype'), /* Safari, Android, iOS */
       url('assets/fonts/muli-v16-latin/muli-v16-latin-600italic.svg#Muli') format('svg'); /* Legacy iOS */
}
/* muli-600 - latin */
@font-face {
  font-family: 'Muli';
  font-style: normal;
  font-weight: 600;
  src: url('assets/fonts/muli-v16-latin/muli-v16-latin-600.eot'); /* IE9 Compat Modes */
  src: local('Muli SemiBold'), local('Muli-SemiBold'),
       url('assets/fonts/muli-v16-latin/muli-v16-latin-600.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('assets/fonts/muli-v16-latin/muli-v16-latin-600.woff2') format('woff2'), /* Super Modern Browsers */
       url('assets/fonts/muli-v16-latin/muli-v16-latin-600.woff') format('woff'), /* Modern Browsers */
       url('assets/fonts/muli-v16-latin/muli-v16-latin-600.ttf') format('truetype'), /* Safari, Android, iOS */
       url('assets/fonts/muli-v16-latin/muli-v16-latin-600.svg#Muli') format('svg'); /* Legacy iOS */
}
/* muli-700 - latin */
@font-face {
  font-family: 'Muli';
  font-style: normal;
  font-weight: 700;
  src: url('assets/fonts/muli-v16-latin/muli-v16-latin-700.eot'); /* IE9 Compat Modes */
  src: local('Muli Bold'), local('Muli-Bold'),
       url('assets/fonts/muli-v16-latin/muli-v16-latin-700.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('assets/fonts/muli-v16-latin/muli-v16-latin-700.woff2') format('woff2'), /* Super Modern Browsers */
       url('assets/fonts/muli-v16-latin/muli-v16-latin-700.woff') format('woff'), /* Modern Browsers */
       url('assets/fonts/muli-v16-latin/muli-v16-latin-700.ttf') format('truetype'), /* Safari, Android, iOS */
       url('assets/fonts/muli-v16-latin/muli-v16-latin-700.svg#Muli') format('svg'); /* Legacy iOS */
}

html,
body {
  height: 100%;
}
@media (max-width: 280px) {
  html,
  body {
    min-width: 280px;
    position: relative;
  }
}
body {
  background:#f2f2f2;
  font-family: 'Muli';
  font-weight: 600;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
/*#app-content {
  height: 100%;
}*/
.flex-container {
  display: -webkit-box!important;
  display: -ms-flexbox!important;
  display: flex!important;
}
.flex-row {
  -webkit-box-orient: horizontal!important;
  -webkit-box-direction: normal!important;
  -ms-flex-direction: row!important;
  flex-direction: row!important;
}
.flex-column {
  -webkit-box-orient: vertical!important;
  -webkit-box-direction: normal!important;
  -ms-flex-direction: column!important;
  flex-direction: column!important;
}
.align-items-end {
  -webkit-box-align: end!important;
  -ms-flex-align: end!important;
  align-items: flex-end!important;
}
.align-items-center {
  -webkit-box-align: center!important;
  -ms-flex-align: center!important;
  align-items: center!important;
}
#app {
  height: 100%;
}
/* content main */
#main-content {
  width: 100%;
  height: 100%;
  padding: 80px 0 0 0;
}
#overlay {
  width: 0%;
  height: 0%;
  position: absolute;
  background: rgba(0,0,0,0.2);
  top: 0;
  left: 0;
  z-index: 50;
  opacity: 0;
  transition: opacity 0.2s ease-in-out, width 0s 0.2s, height 0s 0.2s;
}
.expanded-small-overview {
  overflow: hidden;
}
.expanded-small-overview #overlay {
  width: 100%;
  height: 100%;
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
}
@media(min-width:400px) {
  #main-content {
    /*padding: 90px 0 0 0;*/
  }
}
@media(min-width:767px) {
  #main-content {
    padding: 90px 0 0 102px;
  }
}
@media(min-width:1180px) {
  #main-content {
    padding: 90px 0 0 280px;
  }
  .closed-large-overview #main-content {
    padding: 90px 0 0 102px;
  }
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  position: relative;
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}

.buttonseperator {
  line-height: 1.8;
  margin: 0;
  color: $secondaryFontColor;
  text-align: center;
}

/* Global Swiper Styles */

.swiper-pagination {
  text-align: center;
  transform: translate3d(0,0,0);
  z-index: 10;
  width: 100%;
  margin: 30px 0 10px 0;
}
.swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 100%;
  background: #DADADA;
  margin: 0 4px;
}
.swiper-pagination-bullet-active {
  background: #6E6E6E;
}
.swiper-button-next,
.swiper-button-prev {
  position: absolute;
  top: 50%;
  /*
  width: 36px;
  height: 36px;
  */
  width: 42px;
  height: 42px;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top:50%;
  transform: translateY(-48px);
  border-radius: 23px;
  -webkit-box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.08);
  -moz-box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.08);
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.08);
  opacity: 1;
  transition-duration: 0.2s;
}
.swiper-button-prev{
  left: 4px;
  /*
  transform: translateY(-48px) rotate(180deg);
  */
  ransform: translateY(-54px) rotate(180deg);
  display: none;
}
.swiper-button-next {
  right: 4px;
  /*
  transform: translateY(-48px);
  */
  transform: translateY(-54px);
}
@media(min-width:767px) {
  .swiper-button-prev{
    left: 12px;
    transform: translateY(-52px) rotate(180deg);
    display: block;
  }
  .swiper-button-next {
    transform: translateY(-52px);
    right: 12px;
  }
  .swiper-button-next,
  .swiper-button-prev {
    width: 46px;
    height: 46px;
  }
}
</style>
